<nb-card class="dlg-container mb-0 mobilePopup" style="max-height:95vh;max-width:95vw; height: auto !important;">
    <nb-card-header class="d-flex align-items-center title">
      <div class="title">Upgrade your account</div>
      <button nbButton static="basic" ghost shape="round" size="small" (click)="Close()" class="ml-auto">
        <nb-icon icon="close"></nb-icon>
      </button>
    </nb-card-header>

    <nb-card-body class="text-center">
      <h2>You need to upgrade your account to a premium paid subscription to enjoy some features.</h2>
      <nb-icon icon="crown" pack="fas" status="warning" style="font-size: 4rem;"></nb-icon>
      <br><br>
      <h2>Upgrade today and get access to</h2>
      <div class="mb-4" style="max-width:300px; margin-left:auto; margin-right:auto; text-align:left">
        <ul>
          <li>
            Archive/Unarchive Clients.
          </li>
          <li>
            Customized Branding.
          </li>
          <li>
            Train more clients. 
          </li>
          <li>
            Unlimited Templates and customs items.
          </li>
        </ul>
      </div>

      <button nbButton  (click)="onPremium()" class="m-1 btn-circle btn-xl btn-main">
        UPGRADE TO PRO
      </button>
      <button nbButton  ghost (click)="Close()" class="m-1 btn-circle btn-xl btn-back">No thanks</button>
    </nb-card-body>
  </nb-card>